import(/* webpackMode: "eager", webpackExports: ["useAnimateMini"] */ "/app/node_modules/framer-motion/dist/es/animation/hooks/use-animate-style.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAnimate"] */ "/app/node_modules/framer-motion/dist/es/animation/hooks/use-animate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAnimatedState"] */ "/app/node_modules/framer-motion/dist/es/animation/hooks/use-animated-state.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAnimation","useAnimationControls"] */ "/app/node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatePresence"] */ "/app/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PopChild"] */ "/app/node_modules/framer-motion/dist/es/components/AnimatePresence/PopChild.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PresenceChild"] */ "/app/node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["usePresenceData"] */ "/app/node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence-data.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsPresent","usePresence"] */ "/app/node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AnimateSharedLayout"] */ "/app/node_modules/framer-motion/dist/es/components/AnimateSharedLayout.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutGroup"] */ "/app/node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["LazyMotion"] */ "/app/node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MotionConfig"] */ "/app/node_modules/framer-motion/dist/es/components/MotionConfig/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ReorderGroup"] */ "/app/node_modules/framer-motion/dist/es/components/Reorder/Group.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ReorderItem"] */ "/app/node_modules/framer-motion/dist/es/components/Reorder/Item.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["DeprecatedLayoutGroupContext"] */ "/app/node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutGroupContext"] */ "/app/node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MotionConfigContext"] */ "/app/node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MotionContext"] */ "/app/node_modules/framer-motion/dist/es/context/MotionContext/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PresenceContext"] */ "/app/node_modules/framer-motion/dist/es/context/PresenceContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchLayoutGroupContext"] */ "/app/node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useDomEvent"] */ "/app/node_modules/framer-motion/dist/es/events/use-dom-event.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["createMotionComponent"] */ "/app/node_modules/framer-motion/dist/es/motion/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["makeUseVisualState"] */ "/app/node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["domAnimation"] */ "/app/node_modules/framer-motion/dist/es/render/dom/features-animation.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["domMax"] */ "/app/node_modules/framer-motion/dist/es/render/dom/features-max.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["domMin"] */ "/app/node_modules/framer-motion/dist/es/render/dom/features-min.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useReducedMotionConfig"] */ "/app/node_modules/framer-motion/dist/es/utils/reduced-motion/use-reduced-motion-config.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useReducedMotion"] */ "/app/node_modules/framer-motion/dist/es/utils/reduced-motion/use-reduced-motion.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAnimationFrame"] */ "/app/node_modules/framer-motion/dist/es/utils/use-animation-frame.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useConstant"] */ "/app/node_modules/framer-motion/dist/es/utils/use-constant.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCycle"] */ "/app/node_modules/framer-motion/dist/es/utils/use-cycle.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useForceUpdate"] */ "/app/node_modules/framer-motion/dist/es/utils/use-force-update.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInView"] */ "/app/node_modules/framer-motion/dist/es/utils/use-in-view.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["disableInstantTransitions","useInstantTransition"] */ "/app/node_modules/framer-motion/dist/es/utils/use-instant-transition.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsomorphicLayoutEffect"] */ "/app/node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMotionValueEvent"] */ "/app/node_modules/framer-motion/dist/es/utils/use-motion-value-event.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["usePageInView"] */ "/app/node_modules/framer-motion/dist/es/utils/use-page-in-view.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useUnmountEffect"] */ "/app/node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useFollowValue"] */ "/app/node_modules/framer-motion/dist/es/value/use-follow-value.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInvertedScale"] */ "/app/node_modules/framer-motion/dist/es/value/use-inverted-scale.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMotionTemplate"] */ "/app/node_modules/framer-motion/dist/es/value/use-motion-template.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMotionValue"] */ "/app/node_modules/framer-motion/dist/es/value/use-motion-value.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/framer-motion/dist/es/value/use-scroll.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useSpring"] */ "/app/node_modules/framer-motion/dist/es/value/use-spring.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useTime"] */ "/app/node_modules/framer-motion/dist/es/value/use-time.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useTransform"] */ "/app/node_modules/framer-motion/dist/es/value/use-transform.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useVelocity"] */ "/app/node_modules/framer-motion/dist/es/value/use-velocity.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useWillChange"] */ "/app/node_modules/framer-motion/dist/es/value/use-will-change/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineDetector"] */ "/app/src/app/_components/OfflineDetector.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/app/src/features/shared/providers/ReactQueryProvider.tsx");
